"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const useStyles = core_1.makeStyles((theme) => ({
    checkbox: {
        marginRight: theme.spacing(0.4),
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.Mui-checked': {
            color: theme.palette.info.dark,
        },
        '& .MuiSvgIcon-root': {
            height: '16px',
            width: '16px',
        },
    },
    checkboxWithDesc: {
        alignSelf: 'flex-start',
    },
    checkboxLabel: {
        marginLeft: 0,
    },
    checkboxLabelWitDesc: {
        '& > .MuiFormControlLabel-label': {
            marginTop: '-2px',
        },
    },
}));
/**
 * A Checkboxes allow the user to select one or more items from a set.
 */
const Checkbox = ({ children, checked, disabled, description, indeterminate = false, onChange, controlId, ariaDescribedby, ariaLabel, ariaLabelledby, name, value, }) => {
    const classes = useStyles();
    const label = (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        description && (react_1.default.createElement(core_1.Typography, { variant: "subtitle1", component: "div" }, description))));
    const muiCheckBox = (react_1.default.createElement(core_1.Checkbox, { disableRipple: true, className: clsx_1.default(classes.checkbox, { [classes.checkboxWithDesc]: description }), id: controlId, checked: checked, disabled: disabled, indeterminate: indeterminate, onChange: onChange, value: value, inputProps: {
            'aria-describedby': ariaDescribedby,
            'aria-label': ariaLabel,
            'aria-labelledby': ariaLabelledby,
            name,
        } }));
    return (react_1.default.createElement(core_1.FormControlLabel, { control: muiCheckBox, label: label, className: clsx_1.default(classes.checkboxLabel, { [classes.checkboxLabelWitDesc]: description }) }));
};
exports.default = Checkbox;
//# sourceMappingURL=index.js.map